import { Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core'
import { MatPaginator } from '@angular/material/paginator'
import { MatTableDataSource } from '@angular/material/table'
import { Store } from '@ngrx/store'
import { OpenRentalOverlay } from '@tv3/store/overlay/overlay.actions'

@Component({
  selector: 'app-rental-results-table',
  templateUrl: './rental-results-table.component.html',
  styles: [
    `
      table {
        width: 100%;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RentalResultsTableComponent implements OnInit {
  @Input() results: any[] = []

  @ViewChild('paginator') set paginator(p: MatPaginator) {
    this.dataSource.paginator = p
  }

  dataSource = new MatTableDataSource<any>()
  displayedColumns = ['name', 'phone', 'address', 'currency']
  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.dataSource.data = this.results || []
  }

  onEdit(rental: any) {
    this.store.dispatch(OpenRentalOverlay({ rentalId: rental.pkey }))
  }
}
